<template>
  <div class="">
    <v-tabs
      v-model="active"
      color="primary"
      dark
      slider-color="black"
    >
      <v-tab key="gate-entry" ripple>Gate Entry Ticket</v-tab>
      <v-tab key="tour-operator" ripple>Tourism Partners & Operators</v-tab>
      <v-tab key="groups" ripple>Group & School bookings</v-tab>
      <v-tab key="membership" ripple>Membership Booking</v-tab>
      <v-tab key="non-paying" ripple>Authorized Visitors</v-tab>
    </v-tabs>
    <v-tabs-items v-model="active">
      <v-tab-item key="gate-entry">
        <v-card flat>
          <gate-entry-ticket></gate-entry-ticket>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tour-operator">
        <v-card flat>
          <tour-operator-booking></tour-operator-booking>
        </v-card>
      </v-tab-item>
      <v-tab-item key="groups">
        <v-card flat>
          <group-booking></group-booking>
        </v-card>
      </v-tab-item>
      <v-tab-item key="membership">
        <v-card flat>
          <member-booking></member-booking>
        </v-card>
      </v-tab-item>
      <v-tab-item key="non-paying">
        <v-card flat>
          <new-visitor></new-visitor>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import GateEntryTicket from './Snippets/GateEntryTicket'
import TourOperatorBooking from './Snippets/TourOperatorBooking'
import MemberBooking from './Snippets/MemberBooking'
import NewVisitor from '../Visitors/NewVisitor'
import GroupBooking from './Snippets/GroupBooking'

export default {
  components: {
    GroupBooking,
    NewVisitor,
    MemberBooking,
    TourOperatorBooking,
    GateEntryTicket },
  data () {
    return {
      active: null
    }
  },
  created () {
    this.$store.dispatch('get_all_vehicle_fees')
    this.$store.dispatch('get_all_destinations')
    this.$store.dispatch('get_all_conservation_fees')
    this.$store.dispatch('get_active_camping')
    this.$store.dispatch('get_active_accommodation')
    this.$store.dispatch('get_active_facilities')
    this.$store.dispatch('get_active_activities')
    localStorage.setItem('vehicle_data', JSON.stringify([]))
    localStorage.setItem('conservation_data', JSON.stringify([]))
    localStorage.setItem('facility_data', JSON.stringify([]))
    localStorage.setItem('activity_data', JSON.stringify([]))
    localStorage.setItem('camping_multi_data', JSON.stringify([]))
    localStorage.setItem('old_facility_data', JSON.stringify([]))
    localStorage.setItem('old_activity_data', JSON.stringify([]))
    this.$store.commit('REMOVE_CHOSEN_FACILITIES')
    this.$store.commit('REMOVE_CHOSEN_ACTIVITIES')
    this.$store.commit('REMOVE_MULTI_ARRIVALS')
    this.$store.state.ActivityStore.bookedInventory = []
    this.$store.state.FacilityStore.bookedFacilities = []
  }
}
</script>

<style>

</style>
